import React, { useState } from 'react';
import './CreativeView.css';

const CreativeView: React.FC = () => {
  const [selectedBrand, setSelectedBrand] = useState<'gravely' | 'ariens'>('gravely');

  return (
    <div className="creative-view">
      <div className="creative-header">
        <div className="creative-title-section">
          <h2 className="creative-title">Creative Assets</h2>
          <p className="creative-subtitle">
            Download marketing materials, product images, and brand assets for your advertising
          </p>
        </div>
      </div>

      <div className="creative-controls">
        <div className="brand-selector">
          <button
            className={`brand-btn ${selectedBrand === 'gravely' ? 'active' : ''}`}
            onClick={() => setSelectedBrand('gravely')}
          >
            <img src="/img/gravely_new.svg" alt="Gravely" className="brand-logo gravely-selector-logo" />
            <span>Gravely Assets</span>
          </button>
          <button
            className={`brand-btn ${selectedBrand === 'ariens' ? 'active' : ''}`}
            onClick={() => setSelectedBrand('ariens')}
          >
            <img src="/img/ariens.svg" alt="Ariens" className="brand-logo ariens-selector-logo" />
            <span>Ariens Assets</span>
          </button>
        </div>
      </div>

      <div className="creative-content">
        <div className="dam-container">
          {selectedBrand === 'gravely' && (
            <iframe
              src="https://brandfolder.com/ariensco/gravely"
              className="dam-iframe"
              title="Gravely Digital Asset Manager"
              frameBorder="0"
              allowFullScreen
            />
          )}
          {selectedBrand === 'ariens' && (
            <iframe
              src="https://brandfolder.com/ariensco/ariens"
              className="dam-iframe"
              title="Ariens Digital Asset Manager"
              frameBorder="0"
              allowFullScreen
            />
          )}
        </div>
      </div>

    </div>
  );
};

export default CreativeView;